import {
  ArrowTopRightOnSquareIcon,
  EnvelopeIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';
import { ContactPageSEO } from '../seo/seo';

function ContactUs() {
  return (
    <section className="relative overflow-hidden py-24">
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-indigo-600/20 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-pink-500/20 blur-3xl" />
      </div>

      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-4xl text-center">
          <span className="rounded-full border border-indigo-500/20 bg-indigo-500/10 px-4 py-1 text-sm font-medium text-indigo-600 dark:text-indigo-300">
            Global Engineering Partner
          </span>

          <h1 className="mt-6 text-5xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white sm:text-6xl">
            Build Faster With a
            <span className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 bg-clip-text text-transparent">
              {' '}
              Top-Tier Engineering Team
            </span>
          </h1>

          <p className="mx-auto mt-8 max-w-3xl text-lg leading-8 text-gray-600 dark:text-gray-300">
            We help startups and enterprises scale product development with elite software engineers,
            AI specialists, and technology consultants from Sri Lanka.
          </p>

          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-gray-500 dark:text-gray-400">
            At Akwid Labs, we partner with ambitious companies across Europe, Australia, New Zealand, America and beyond to fill
            engineering gaps, accelerate delivery, and build modern digital products with speed and
            precision.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="mt-20 grid gap-8 lg:grid-cols-2">
          {/* Email Card */}
          <a
            href="mailto:hello@akwidlabs.com"
            className="group relative overflow-hidden rounded-3xl border border-gray-200 bg-white p-10 shadow-xl transition duration-300 hover:-translate-y-1 hover:shadow-2xl dark:border-gray-800 dark:bg-gray-900"
          >
            <div className="absolute right-0 top-0 h-40 w-40 rounded-full bg-indigo-500/10 blur-3xl transition group-hover:bg-indigo-500/20" />

            <div className="relative">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-500/10">
                <EnvelopeIcon className="h-7 w-7 text-indigo-600 dark:text-indigo-400" />
              </div>

              <h3 className="mt-8 text-2xl font-bold text-gray-900 dark:text-white">
                Contact Our Team
              </h3>

              <p className="mt-4 text-base leading-7 text-gray-600 dark:text-gray-300">
                Reach out to discuss partnerships, dedicated engineering teams, AI solutions, or
                product development opportunities.
              </p>

              <div className="mt-8 flex items-center gap-2 text-lg font-semibold text-indigo-600 dark:text-indigo-400">
                hello@akwidlabs.com
                <ArrowTopRightOnSquareIcon className="h-5 w-5 transition group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </div>
          </a>

          {/* CEO Meeting Card */}
          <a
            href="https://calendar.app.google/mwLoqcG1gy8mWRLP9"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 p-10 shadow-2xl transition duration-300 hover:-translate-y-1 hover:shadow-[0_25px_60px_rgba(99,102,241,0.45)]"
          >
            <div className="absolute inset-0 bg-white/5 opacity-0 transition group-hover:opacity-100" />

            <div className="relative">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 backdrop-blur-lg">
                <PhoneIcon className="h-7 w-7 text-white" />
              </div>

              <h3 className="mt-8 text-2xl font-bold text-white">
                Schedule a Strategy Call
              </h3>

              <p className="mt-4 text-base leading-7 text-white/90">
                Book a direct meeting with our CEO and Chief Architect to discuss scaling your
                engineering capabilities, AI initiatives, or long-term collaboration opportunities.
              </p>

              <div className="mt-8 flex items-center gap-2 text-lg font-semibold text-white">
                Book a Meeting
                <ArrowTopRightOnSquareIcon className="h-5 w-5 transition group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </div>
          </a>
        </div>

        {/* Bottom Statement */}
        <div className="mx-auto mt-24 max-w-4xl rounded-3xl border border-gray-200 bg-white/70 p-10 text-center shadow-xl backdrop-blur-xl dark:border-gray-800 dark:bg-gray-900/70">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Engineering Excellence With Global Standards
          </h2>

          <p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300">
            We work with companies that move fast, think long term, and value high-quality
            engineering. From AI-powered platforms to scalable enterprise systems, our teams help
            businesses execute ambitious ideas with confidence.
          </p>
        </div>
      </div>
    </section>
  );
}

export default function ContactUsPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <ContactPageSEO />
      <ContactUs />
    </div>
  );
}